import { ArrowUpOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { Card, Layout, Menu } from "antd";
import type { MenuProps } from "antd";
import React, { ReactNode, useState } from "react";
import styles from "./DualViewSideDrawer.module.css";

type DualViewSideDrawerContentProps = {
  spotlightQAContent: ReactNode;
  arrowsContent: ReactNode;
  floorplansContent?: ReactNode;
  onClickMenuItem: () => void;
  isCollapsed: boolean;
};

export type DrawerMenuItem = "QA" | "Arrows" | "Floorplans";

export const DualViewSideDrawerContent = (
  props: DualViewSideDrawerContentProps,
) => {
  const [menuItem, setMenuItem] = useState<DrawerMenuItem>("QA");

  const onClickMenuItem = (itemKey: DrawerMenuItem) => {
    setMenuItem(itemKey);
    props.onClickMenuItem();
  };

  const items: MenuProps["items"] = [
    {
      key: "Spotlight QA",
      title: "Spotlight QA",
      label: "QA",
      icon: <div>QA</div>,
      onClick: () => onClickMenuItem("QA"),
    },
    {
      key: "Arrows",
      title: "Arrows",
      label: "Arrows",
      icon: <ArrowUpOutlined />,
      onClick: () => onClickMenuItem("Arrows"),
    },
    {
      key: "Floorplans",
      title: "Floor Plan",
      icon: <EnvironmentOutlined />,
      className: styles.lastMenuItem,
      onClick: () => onClickMenuItem("Floorplans"),
    },
  ];

  return (
    <Layout className={styles.layout}>
      <Layout.Content>
        {!props.isCollapsed && (
          <Card bordered={false} className={styles.card}>
            {menuItem === "QA"
              ? props.spotlightQAContent
              : menuItem === "Arrows"
              ? props.arrowsContent
              : props.floorplansContent}
          </Card>
        )}
      </Layout.Content>
      <Layout.Sider defaultCollapsed={true} theme="light">
        <Menu items={items} />
      </Layout.Sider>
    </Layout>
  );
};
